import _ from 'lodash'

import { utils } from 'frontend-js-shared'

import access from '@/lib/access.js'
import types from '@/store/modules/access/accessTypes.js'

async function findAccessibleOrganization(store, organizationId) {
  if (!store.state.access.hasFetchedAccountOrganizations) {
    await store.dispatch('fetchAccountOrganizations')
  }
  return store.state.access.accountOrganizations.find(organizationOption =>
    utils.isSameId(organizationOption.id, organizationId)
  )
}

export function createOrgSwitchNavigationGuard(store) {
  return async function orgSwitchNavigationGuard(to, from, next) {
    const targetOrganizationId = to.params?.organizationId
    const isPlatformAdmin = access.isAdmin(store.getters.account)
    if (
      !store.getters.token ||
      !targetOrganizationId ||
      isPlatformAdmin
    ) {
      return next()
    }

    const isCurrentOrganization = utils.isSameId(
      store.getters.organizationId,
      targetOrganizationId
    )
    if (isCurrentOrganization) return next()

    let targetOrganization = null
    try {
      targetOrganization = await findAccessibleOrganization(
        store,
        targetOrganizationId
      )
    } catch (error) {
      return next()
    }
    if (!targetOrganization) return next()

    store.commit(types.SET_PENDING_ORG_SWITCH, {
      pendingOrgSwitch: {
        organizationId: targetOrganization.id,
        organizationName: targetOrganization.name,
        status: targetOrganization.status,
        redirectTo: to.fullPath,
      },
    })

    return _.isEmpty(from.matched) ? next('/home') : next(false)
  }
}
